<template>
  <div id="your-current-request" v-bind="$attrs" :class="loading ? 'hide' : ''">
    <div class="section" id="school-confirmation">
      <div class="info-section">
        <p class="info-title">
          School&nbsp;
          <a
            v-if="editable"
            class="edit-link edit-loan-config-link"
            href="#/"
            @click="emit('openSchoolConfirmationModal', true)"
            >Edit</a
          >
        </p>
        <div class="info">
          <p>
            {{ schoolName }}
            <FontAwesomeIcon
              v-if="schoolNameError && schoolNameError?.error"
              class="icon incomplete"
              :icon="['fas', 'circle-exclamation']"
              :title="schoolNameError?.errorMessage"
							style="color: #bb0000"
            ></FontAwesomeIcon>
          </p>
        </div>
      </div>
      <div class="info-section">
        <p class="info-title">
          Academic Terms&nbsp;
          <a
            v-if="editable"
            href="#/"
            @click="emit('openSchoolConfirmationModal', true)"
            class="edit-link edit-loan-config-link"
            >Edit</a
          >
        </p>
        <div class="info" v-if="disbursements.length > 0">
          <div v-for="(disbursement, index) in disbursements" :key="index" class="disbursement">
            <p class="amount">{{ formatMoney(disbursement.amount) }}</p>
            <p class="term">{{ disbursement.term || "Not Yet Selected" }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="info-section">
      <p class="info-title">
        Funds Requested for Academic Term&nbsp;
        <a
          v-if="editable"
          class="edit-link edit-loan-config-link"
          href="#/"
          @click="emit('openBorrowAmountModal', true)"
          >Edit</a
        >
      </p>
      <div class="info">
        {{ requestedAmount }}
      </div>
    </div>
    <div class="info-section">
      <p class="info-title">
        Interest Rate&nbsp;
        <a
          v-if="editable"
          class="edit-link edit-loan-config-link"
          href="#/"
          @click="emit('openLoanOptionsModal', true)"
          >Edit</a
        >
      </p>
      <div class="info">
        <p>
          {{ rateSelectionDisplay }}
        </p>
      </div>
    </div>
    <div class="info-section">
      <p class="info-title">
        Repayment Type&nbsp;
        <a
          v-if="editable"
          class="edit-link edit-loan-config-link"
          href="#/"
          @click="emit('openLoanOptionsModal', true)"
          >Edit</a
        >
      </p>

      <div class="info">
        <p>
          {{ repaymentTypeDisplay || "Not Yet Selected" }}
        </p>
      </div>
    </div>
    <div class="info-section" v-if="showEstimatedMonthlyPayments">
      <p class="info-title">
        Estimated Monthly&nbsp;{{ monthlyInSchoolPaymentLabel }}
        Payments
      </p>
      <div class="info">
        {{ details?.monthlyInSchoolPaymentsDisplay }}
        <span
          v-if="details?.monthlyInSchoolPaymentsDisplay !== 'Not Yet Selected'"
          :class="loading ? 'hide' : ''"
          >/ Month</span
        >
      </div>
    </div>
    <div class="info-section" v-if="showEstimatedMonthlyPayments">
      <p class="info-title">
        Estimated Monthly&nbsp;{{ monthlyPostSchoolPaymentLabel }}
        Payments
      </p>
      <div class="info">
        {{ details?.monthlyPostGradPaymentsDisplay }}
        <span v-if="details?.monthlyPostGradPaymentsDisplay !== 'Not Yet Selected'">/ Month</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

useStore();

withDefaults(defineProps<{ loading: boolean }>(), {
  loading: false,
});

const emit = defineEmits<{
  (e: "openSchoolConfirmationModal", payload: boolean): void;
  (e: "openBorrowAmountModal", payload: boolean): void;
  (e: "openLoanOptionsModal", payload: boolean): void;
}>();

const {
  details,
  disbursements,
  editable,
  formatMoney,
  monthlyInSchoolPaymentLabel,
  monthlyPostSchoolPaymentLabel,
  rateSelectionDisplay,
  repaymentTypeDisplay,
  requestedAmount,
  schoolName,
  schoolNameError,
  showEstimatedMonthlyPayments,
} = useApplicationInfo();
</script>

<style scoped>
.info-section {
  width: 100%;
  margin-bottom: 10px;
}

.info-title {
  font-weight: 700;
  margin-bottom: 0;
}

.info-title a.edit-link {
  color: #767676;
  font-size: 0.8em;
  font-weight: 400;
  margin: 0;
  text-align: end;
  text-decoration: underline;
}

.info {
  display: flex;
  justify-content: flex-start;
}
.info p {
  margin-bottom: 0;
}
.info p:first-child {
  margin-right: 30px;
}

.disbursement p {
  margin: 0;
}

.hide {
  display: none;
}
/*  mobile */
@media (max-width: 576px) {
}
</style>
